// extracted by mini-css-extract-plugin
export var container = "_6q-0";
export var fallback = "_6q-5";
export var fallbackIcon = "_6q-6";
export var hidden = "_6q-2";
export var image = "_6q-3";
export var loaded = "_6q-4";
export var placeholder = "_6q-1";